export default __webpack_public_path__ + "static/media/invitations-stationery.bc834cfc.jpg";